import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import appConfig from 'config/app.config';
import {languagesData} from 'data/languages-data';
import LoginDefault from './login-default/login-default';
import LoginOpenId from './login-open-id/login-open-id';
import Select from 'components/select/select';
import aeroteam from 'assets/images/aeroteam.png';
import './login.scss';

const Login = ({languageId, gameType, authErrMsg, companyData, updateLanguage}) => {

	let LoginComponent = LoginDefault;
	if (companyData && companyData.loginConfig) {
		if (companyData.loginConfig.loginMethod === 'openId') {
			LoginComponent = LoginOpenId;
		} else {
			console.error('warning, unknown login method: ', companyData.loginConfig.loginMethod);
		}
	}

	return (
		<div className="Login">
			<Link to="/" className="Login-link">
				<img src={aeroteam} className="Login-aeroteamLogo" alt="aeroteam logo" />
			</Link>
			<div className="Login-language">
				<Select 
					isDisabled={false}
					type="login"
					options={languagesData}
					defaultId={appConfig.defaultLanguage}
					selectedId={languageId}
					onSelect={updateLanguage}
				/>
			</div>
			<LoginComponent 
				languageId={languageId}
				gameType={gameType}
				authErrMsg={authErrMsg}
				companyData={companyData}
			/>	
		</div>
	);
};

Login.propTypes = {
	languageId: PropTypes.string.isRequired,
	gameType: PropTypes.string.isRequired,
	authErrMsg: PropTypes.string,
	companyData: PropTypes.object,
	updateLanguage: PropTypes.func.isRequired
};

export default Login;